// SHARED ERRORS
const GENETIC_INVALID_TEXT_FIELD = 'Please use only letters, spaces, dashes(-), and apostrophes(\').';

// INPUT ERRORS
export const FISTNAME_EMPTY_ERROR = 'Please enter your first name.';
export const FISTNAME_INVALID = GENETIC_INVALID_TEXT_FIELD;
export const LASTNAME_EMPTY_ERROR = 'Please enter your last name.';
export const LASTNAME_INVALID = GENETIC_INVALID_TEXT_FIELD;
export const CCNAME_EMPTY_ERROR = 'Please enter the name on your credit card.';
export const CCNAME_INVALID = GENETIC_INVALID_TEXT_FIELD;
export const EMAIL_EMPTY_ERROR = 'Please enter your email address.';
export const EMAIL_INVALID = 'Please enter a valid email address including the @ symbol and domain (i.e. youremail@domain.com).';
export const EMAIL_ALREADY_USED_ERROR = 'That email is already in use. Please use a unique email address to sign up.';
export const PHONENUMBER_EMPTY_ERROR = 'Please enter your 10 digit phone number.';
export const PHONENUMBER_INVALID = 'Please use only numbers.';
export const STREET1_EMPTY_ERROR = 'Please enter your street address.';
export const STREET1_INVALID = 'Invalid character(s). Please use only letters, numbers, spaces, periods, commas, parentheses and dashes.';
export const CITY_EMPTY_ERROR = 'Please enter your city.';
export const CITY_INVALID = 'Invalid character(s). Please use only letters, spaces, and dashes.';
export const ZIPCODE_LENGTH_ERROR = 'Zip codes must be 3-12 characters.';
export const ZIPCODE_INVALID = 'Invalid character(s). Please use only letters and numbers.';
export const CC_INVALID = 'Please enter a valid credit card number.';
export const CVV_LENGTH_ERROR = 'Security code must be either 3 or 4 digits.';
export const CVV_INVALID = 'Please use only numbers.';
export const EXPDATE_FORMAT_ERROR = 'Please use the format MM/YY.';
export const EXPDATE_INVALID_FORMAT = 'Invalid character(s). Please use only numbers.';
export const EXPDATE_INVALID_DATE = 'Please enter a valid expiration date.';
export const PIN_LENGTH_ERROR = 'Your verification code must be 4 digits long.';
export const PIN_INVALID = 'Please use only numbers.';
export const USERNAME_EMPTY_ERROR = 'Please enter a username.';
export const USERNAME_LENGTH_ERROR = 'Please use at least 3 characters.';
export const USERNAME_INVALID_CHARACTERS = 'Please use only numbers and letters.';
export const USERNAME_ALREADY_USED_ERROR = 'Username already taken. Please enter a new username.';
export const USERNAME_INVALID = 'Usernames must be at least 3 characters. Please use only letters and numbers.';
export const PASSWORD_EMPTY_ERROR = 'Please enter a password.';
export const PASSWORD_INVALID = 'Please ensure your password meets the requirements below.';
export const AUTOCOMPLETE_EMPTY_ERROR = 'Please enter your street address.';
export const AUTOCOMPLETE_INVALID = 'Please enter a valid street address.';
export const STATE_INVALID = 'Please select your state.';
export const COUNTRY_INVALID = 'Please select your country.';

// error handling messages for payment estimate
export const PAYMENT_ESTIMATE_GENERIC_ERROR = 'Your address is invalid. Please correct any errors below and try submitting your information again.';
export const PAYMENT_ESTIMATE_MISMATCH_COUNTRY = 'This country doesn\'t match the zip code you\'ve selected. Please try again.';
export const PAYMENT_ESTIMATE_NO_TRIAL_ACCOUNT = 'You do not have a trial account.';

// error handling for number picker
export const AREA_CODE_GENERIC_ERROR = 'Area codes must be 3 digits long.';
export const AREA_CODE_NO_RESULTS_ERROR = 'No phone numbers found. Please try again.';
export const TRANSFER_NUMBER_GENERIC_ERROR = 'Please enter a 10-digit phone number.';
export const VANITY_SEARCH_GENERIC_ERROR = AREA_CODE_NO_RESULTS_ERROR;

export const SESSION_EXPIRED_ERROR = 'your session has expired please log in again.';

// error handling for flexform
export const FLEX_EXPIRATION_DATE_ERROR = 'Please enter a valid expiration date in the format MM/YY.';
export const FLEX_EXPIRED_FORM = 'We’re sorry, the page has timed-out. Please re-enter your information and submit again.';
export const FLEX_INCOMPLETE_DATA = 'Please provide card number and verification code, and submit again.';

export const NOT_SUPPORTED_CREDIT_CARD_TYPE = 'You\'ve entered a credit card type that is not accepted. Please enter a Visa, Master Card or American Express card.';
export const FLEX_GENERIC_ERROR = 'Oops, something went wrong please reload the page and try again.';
export const NOT_SELECTED_CREDIT_CARD_TYPE = 'Please select one of the options below.';

// error handling for RenewalDisclaimer checkbox
export const RENEWAL_DISCLAIMER_ERROR = 'Please agree to the terms above.';
